import { Component, OnInit } from '@angular/core';
import { UserService } from '@wephone/services/user.service';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { DidService } from '@wephone/services/did.service';
import { EntityManager } from '@wephone-core/wephone-core.module';
import { DidEntity } from '@wephone-core/model/entity/did';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnInit {
  static MaxStep = 4;
  step = 0;
  did: DidEntity;
  constructor(
    private readonly userService: UserService,
    private readonly didService: DidService,
    private readonly em: EntityManager,
    private readonly authService: AuthenticationService
  ) { }

  ngOnInit(): void {

  }

  async goNextStep(): Promise<void> {
    if (this.step >= OnboardingComponent.MaxStep) {
      console.error('Max step has been reached');
      return;
    }
    this.step = this.step + 1;

    if (this.step === 1) {
      // await this.didService.getDidsList(); // TODO: Check necessary
      const dids = await this.em.getRepository('DidRepository').loadObjectList();
      this.did = dids && dids.length ? dids[0] : undefined;

      // this.did = new DidEntity();
      // this.did.number = '0125478542';
      // this.did.id = 1;
    }
  }

  // goPrevStep(): void {
  //   if (this.step <= 0) {
  //     console.error('Min step has been reached');
  //     return;
  //   }
  //   this.step = this.step - 1;
  // }

  downloadWindow(): void {
    console.log('download Windows app');
  }

  downloadIOS(): void {
    console.log('download IOS app');
  }

  async goFinishBoarding(): Promise<void> {
    try {
      await this.userService.markOnboardingDone();
      this.authService.notifyLoginSuccess();
    } catch (error) {
      console.error('Finish boarding error', error);
    }
  }

  async goToHomepage(): Promise<void> {
    await this.goFinishBoarding();
  }
}
